
module.exports = function Personaliser ($host, config) {

  // Dom
  var $message   = $('textarea',          $host);
  var $charLimit = $('[data-char-limit]', $host);

  // State
  var charLimit = parseInt($message.attr('maxlength'), 10);

  // Functions
  function checkMessageLimit () {
    $charLimit.text($message.val().length + '/' + charLimit);
  }

  // Init
  if (!charLimit) {
    console.warn('CharLimitIndicator - no char limit detected - does textarea have a maxlength?');
    $charLimit.hide();
  } else {
    $message.on('change keydown keyup paste focus blur', checkMessageLimit);
    checkMessageLimit();
  }

}

